import { Box, Button, CircularProgress, Grid, InputAdornment, TextField, useTheme } from '@material-ui/core';
import {
  Backdrop,
  CheckboxCheckIconTwoTone,
  CheckInIcon,
  CloseIcon,
  LoadingSpinnerIconTwoTone,
  StyledDialog,
  Typography,
  useNotificationModal,
} from '@room-match/shared-ui-components';
import { CheckInForm } from 'components';
import QrReader from 'modern-react-qr-reader';
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { COLORS } from 'shared/constants/COLORS';
import { ROUTES } from 'shared/constants/ROUTES';
import { CheckinSteps } from 'shared/enums/CheckinSteps';
import { useSetHeaderBack, useSetHeaderTitle } from 'shared/hooks/useSetHeader';
import { checkInService } from 'shared/services/checkInService';
import { profileService } from 'shared/services/profileService';
import { projectService } from 'shared/services/projectService';
import { ls } from 'shared/utils/ls';
import { useDebounce } from 'use-debounce';
import { useStyles } from './CheckIn.styles';
import scanIcon from './scan_icon.png';

const { getProfiles } = profileService();
const { getSingleProject, getSingleOngoingSession } = projectService();
const { getCheckInDetails } = checkInService();

const warning_message =
  "We don't have you scheduled for any session today. Please let the Session Director or Casting Director know that you have an account so they can add you to the correct role/schedule for today's audition.";

const CheckIn = () => {
  const theme = useTheme();
  const { data: profileList, isLoading: isLoadingProfileList } = getProfiles();
  const { handleOpen, isOpen, NotificationModal, handleSetMessage, handleChangeModalType } = useNotificationModal({
    type: 'warning',
  });

  useSetHeaderBack(false);
  useSetHeaderTitle('Check In');
  const { getLS, removeLS } = ls();
  const profileID = getLS('ghosted_profile_id');
  const sessionId = getLS('ghosted_session_id');
  const {
    projectId: projId,
    step,
    sessionId: sessId,
  } = useParams() as { sessionId: string; projectId: string; step: string };
  const [sessionID, setsessionID] = useState(sessId || '');
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const history = useHistory();
  const { data: checkinData, isLoading: checkinLoading } = getCheckInDetails(
    sessionId ? sessionId : sessionID,
    profileID,
  );

  const [projectId, setProjectId] = useState(projId || '');
  const [showQR, setshowQR] = useState(false);
  const [queryValue] = useDebounce(projectId, 500);
  const { data, isLoading, error } = getSingleProject(queryValue, sessId);
  const { data: sessionData, isLoading: sessionDataLoading } = getSingleOngoingSession(queryValue);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setloading] = useState(true);

  const next = () => {
    history.push(`${ROUTES.TALENT.CHECKIN}/${projectId}/${sessionID}/${CheckinSteps.SIZE_CARD}`);
    // captureMessage({
    //   message: 'user check in confirm and next',
    //   data: {
    //     route: `${ROUTES.TALENT.CHECKIN}/${projectId}/${sessionID}/${CheckinSteps.SIZE_CARD}`,
    //   },
    // });
  };

  const inputTouch = () => {};

  useEffect(() => {
    if (error && queryValue) setErrorMessage('Invalid Project ID');
    if (projId && error) {
      handleChangeModalType('error');
      handleSetMessage('Invalid Project ID', '', 'OK');
      handleOpen();
    }
  }, [error, queryValue, projId]);

  useEffect(() => {
    if (!projectId || isLoading) return;
    if (!data) return setErrorMessage('Project not found');
    if (data && sessionData && sessionData?.data?.ongoing_sessions_connection?.nodes?.length === 0) {
      handleChangeModalType('error');
      handleSetMessage('Currently Unavailable', warning_message, 'OK');
      handleOpen();
    } else {
      if (data && sessionData && sessionData?.data?.ongoing_sessions_connection?.nodes?.length > 1) {
        handleChangeModalType('error');
        handleSetMessage('Currently Unavailable', warning_message, 'OK');
        handleOpen();
      } else {
        console.log('set session id', sessionData?.data?.ongoing_sessions_connection?.nodes[0]?.id);

        setsessionID(sessionData?.data?.ongoing_sessions_connection?.nodes[0]?.id || '');
        setErrorMessage('');
      }
    }
  }, [data, sessionData, queryValue]);

  useEffect(() => {
    if (!projId) return;
    if (!checkinData) return;
    if (!step) return next();
    switch (step) {
      case CheckinSteps.SIZE_CARD:
        if (activeStep !== 1) setActiveStep(1);
        break;
      case CheckinSteps.QUESTIONS:
        if (activeStep !== 2) setActiveStep(2);
        break;
      case CheckinSteps.TERMS:
        if (activeStep !== 3) setActiveStep(3);
        break;
      case CheckinSteps.COMPLETE:
        if (activeStep !== 4) setActiveStep(4);
        break;

      default:
        break;
    }
  }, [step, projId, checkinData]);

  useEffect(() => {
    return () => removeLS('prev_url');
  }, []);

  useEffect(() => {
    if (checkinLoading) return;
    if (!sessionID && !sessionId) return;
    if (!checkinData) {
      setErrorMessage('Invalid Session');
      if (projId) {
        handleChangeModalType('error');
        handleSetMessage('Invalid Session', '', 'OK');
        handleOpen();
      }
      return;
    }

    // if (!checkinData) return setErrorMessage('Invalid Session');
    if (checkinData && !checkinData.data) {
      if (projId) {
        removeLS('ghosted_session_id');
        removeLS('ghosted_profile_id');
        // setActiveStep(1);
      }
      setErrorMessage('');
    } else {
      if (projId) {
        removeLS('ghosted_session_id');
        removeLS('ghosted_profile_id');
        // setActiveStep(1);
      }
      setErrorMessage('');

      //change to cater different statuses
      if (
        // checkinData?.data.attributes?.status === 'Overtime' ||
        // checkinData?.data.attributes?.status === 'Late Overtime' ||
        // checkinData?.data.attributes?.status === 'Auditioned' ||
        // checkinData?.data.attributes?.status === 'Late Auditioned' ||
        // checkinData?.data.attributes?.status === 'Overtime Auditioned' ||
        // checkinData?.data.attributes?.status === 'Late Overtime Auditioned' ||
        // checkinData?.data.attributes?.status === 'Checked In' ||
        // checkinData?.data.attributes?.status === 'Late Checked In'
        checkinData?.data.attributes?.undergo_checkin_process
      )
        return setActiveStep(4);
    }
  }, [checkinData, sessionID, sessionId, checkinLoading]);

  const onError = () => {
    setshowQR(false);
  };

  const handleScan = (data: any) => {
    if (data) {
      const id = data.split('/').pop();
      setProjectId(id);
      // captureMessage({
      //   message: 'user check in handle qr scan',
      //   data: { data },
      // });
      setshowQR(false);
      setTimeout(() => {
        setloading(true);
      }, 500);
    }
  };

  const handleQRClick = () => {
    navigator.permissions.query({ name: 'camera' as PermissionName }).then((result) => {
      //check if mobile using navigator.userAgent
      if (navigator.userAgent.includes('Mobile')) {
        return setshowQR(true);
      }
      if (result.state === 'granted') {
        setshowQR(true);
      } else {
        handleChangeModalType('error');
        handleSetMessage('Permission Denied', 'Please allow camera permission in your browser settings', 'OK');
        handleOpen();
      }
    });
  };

  const parseLink = (link: string) => {
    const linkArr = link.split('/');
    const pID = linkArr[linkArr.length - 1];
    setProjectId(pID);
  };

  const pData: any = {
    ...data,
    data: {
      ...data?.data,
      attributes: {
        ...data?.data?.attributes,
        ongoing_session: {
          data:
            sessionData && sessionData?.data?.ongoing_sessions_connection?.nodes[0]
              ? {
                  attributes: sessionData?.data?.ongoing_sessions_connection?.nodes[0],
                  id: sessionData?.data?.ongoing_sessions_connection?.nodes[0]?.id,
                  type: 'casting_session',
                }
              : null,
        },
      },
    },
  };

  const will_proceed = sessionData && sessionData?.data?.ongoing_sessions_connection?.nodes?.length === 1;

  if (activeStep === 0 && projId && (isLoading || checkinLoading)) return <Backdrop isLoading />;

  return (
    <>
      {(activeStep > 0 || projId) && (data || isLoading) && checkinData ? (
        <CheckInForm
          sessionId={sessionID}
          checkinData={checkinData}
          projectId={projectId}
          activeStep={activeStep}
          pData={pData}
        />
      ) : isLoading && projId ? (
        <></>
      ) : (
        <Grid container className={classes.root}>
          <Box component="div" className={classes.qrContainer} onClick={handleQRClick}>
            <img
              src={scanIcon}
              style={{
                width: '30%',
                height: '30%',
                filter: theme.palette.type === 'dark' ? 'invert(1)' : 'invert(0)',
                opacity: 0.8,
              }}
            />
          </Box>
          <Grid item>
            <p style={{ fontSize: 40, fontWeight: 500 }}>Check-In Now</p>
            <p style={{ fontSize: 16 }}>
              Please scan the QR code using your camera or type/paste a link you were provided below
            </p>
            {profileList && profileList.data.length === 0 && !isLoadingProfileList ? (
              <Typography fontSize={14} style={{ margin: '10px 0 -5px', color: COLORS.ERROR }}>
                No profiles found.{' '}
                <Link to={ROUTES.TALENT.PROFILES} className={classes.link}>
                  Click here to create a profile.
                </Link>
              </Typography>
            ) : (
              <React.Fragment />
            )}
            {isLoadingProfileList ? (
              <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}>
                <CircularProgress style={{ width: 15, height: 15, marginRight: 10 }} />
                <p style={{ fontSize: 16 }}>Checking Profiles...</p>
              </div>
            ) : (
              <TextField
                value={projectId}
                id="outlined-basic"
                variant="outlined"
                fullWidth
                placeholder="Type code…"
                className={classes.input}
                onChange={(e) => {
                  if (e.target.value.includes('/')) return parseLink(e.target.value);
                  setProjectId(e.target.value);
                  inputTouch();
                }}
                style={{ maxWidth: 520 }}
                helperText={errorMessage}
                disabled={!(profileList && profileList.data.length > 0)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CheckInIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <React.Fragment>
                      {projectId ? (
                        <React.Fragment>
                          {isLoading || isLoadingProfileList ? (
                            <LoadingSpinnerIconTwoTone style={{ fontSize: 40 }} />
                          ) : data && will_proceed && checkinData ? (
                            <CheckboxCheckIconTwoTone style={{ fontSize: 12 }} />
                          ) : (
                            <CloseIcon style={{ fontSize: 12 }} htmlColor={COLORS.ERROR} />
                          )}
                        </React.Fragment>
                      ) : (
                        <React.Fragment />
                      )}
                    </React.Fragment>
                  ),
                }}
              />
            )}

            <Button
              variant="contained"
              color="primary"
              fullWidth
              className={classes.buttonCls}
              onClick={() => {
                next();
              }}
              disabled={
                (isLoading ? true : data && will_proceed ? false : true) ||
                (!checkinData?.data && !will_proceed) ||
                (isLoadingProfileList ? true : profileList && profileList.data.length > 0 ? false : true)
              }
            >
              Confirm & Next
            </Button>
          </Grid>
          {/* QR */}
          <StyledDialog
            open={showQR}
            onClose={() => {
              setshowQR(false);
              setTimeout(() => {
                setloading(true);
              }, 500);
            }}
            maxWidth="md"
            aria-labelledby="simple-dialog-title"
          >
            <div style={{ position: 'relative' }}>
              {loading ? (
                <div
                  style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 20,
                  }}
                >
                  <CircularProgress style={{ width: 25, height: 25, marginRight: 10 }} />
                  Initializing...
                </div>
              ) : (
                <></>
              )}
              <QrReader
                facingMode={'environment'}
                onLoad={() => setloading(false)}
                delay={500}
                // style={{ height: 300, width: 30 }}
                onError={onError}
                onScan={handleScan}
                style={{ minWidth: 300, minHeight: 100, width: '100%' }}
              />
            </div>
            {!loading && (
              <span style={{ width: '100%', textAlign: 'center', padding: 10, paddingBottom: 15 }}>
                Please move the QR Code close the camera
              </span>
            )}
          </StyledDialog>
          {isOpen && (
            <NotificationModal
              onClose={() => {
                history.push(ROUTES.TALENT.CHECKIN);
              }}
            />
          )}
        </Grid>
      )}
    </>
  );
};

export default CheckIn;
